import React, { useState } from "react";
import { Btn, Image } from "../../../../../AbstractElements";
import { TopLeftToasts } from "../../../../../Constant";
import { Toast, ToastBody } from "reactstrap";
import { dynamicImage } from "../../../../../Service/DynamicImage";

const TopLeftToast = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };
  return (
    <>
      <Btn color="warning" onClick={toggle}>{TopLeftToasts}</Btn>
      <div className="toast-container position-fixed start-0 top-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={open}>
          <div className="toast-header toast-img">
            <Image className="rounded me-2" src={dynamicImage("avtar/profile.png")} alt="profile" />
            <strong className="me-auto">Boho theme</strong>
            <small className="d-sm-block d-none">10 min ago</small>
            <Btn className="btn-close" onClick={() => setOpen(false)}></Btn>
          </div>
          <ToastBody className="toast-dark">
            <strong className="txt-success">Well done!</strong> You successfully read this important message.
          </ToastBody>
        </Toast>
      </div>
    </>
  );
};

export default TopLeftToast;
